export default __webpack_public_path__ + "Poppins-Regular.ttf";